// @tennis-matches/clubmeisterschaft-core – Setup-Context (Werte vom Host, z. B. apps/web)

import React from "react";

/**
 * Context für den Clubmeisterschaft-Setup-Wizard.
 * Muss vom Host (apps/web) mit ClubmeisterschaftSetupProvider gefüllt werden.
 * Enthält: setupState (useTournamentSetup), validation/stepOk (useWizardValidation),
 * wizard (useSetupWizard), onSave, onBootstrapNew.
 */
export const ClubmeisterschaftSetupContext = React.createContext(null);
